import React from 'react';
import Link from 'next/link';
import {parseTextWithLinksAndBold} from '../helpers/parse-text';

type HeadProps = {
  titleH1: string;
  headParagraphs?: string[];
};

const Head = ({ titleH1, headParagraphs }: HeadProps) => {
  return (
    <section className="freight-dictionary-landing__head">
      <div className="container">
        <div className="freight-dictionary-landing__head-content">
          <div className="freight-dictionary-landing__head-description-box">
            <h1 className="freight-dictionary-landing__head-title">
              {titleH1}
            </h1>

            <div className='freight-dictionary-landing__head-text-box'>
              {headParagraphs ?
              headParagraphs.map((paragraph, idx) => (
                <p key={idx} className="freight-dictionary-landing__head-text">
                  {parseTextWithLinksAndBold(paragraph)}
                </p>
              )) : (
                  <p className="freight-dictionary-landing__head-text">
                    {`Find the abbreviation, definition, and use case of ${titleH1}`}
                  </p>
                )
              }
            </div>

            <div className="new-header-hero__links-box">
              <Link className="new-link-block full" href="/membership">
              Get membership NOW!
              </Link>
              {/*<Link className="new-link arrow" href="/company/contact-us">*/}
              {/*  Show more*/}
              {/*  <svg className="link-arrow directionRight" viewBox="0 0 10 10" aria-hidden="true">*/}
              {/*    <path className="link-arrow__line" d="M1 5h7" />*/}
              {/*    <path className="link-arrow__tip" d="M2 1l4 4-4 4" />*/}
              {/*  </svg>*/}
              {/*</Link>*/}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Head;
